module.exports = __webpack_public_path__ + "static/online-deposits-79def795c9b25284f1a36f0bf2884647.jpg";